/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */




import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import React from 'react';
import { RatingForm, RatingFormProps } from './RatingForm';

interface RatingModalProps extends RatingFormProps {
  toggle: () => void;
  isOpen: boolean;
}

export const RatingModal = (props: RatingModalProps) => {
  const { toggle, isOpen, onSubmit, ...rest } = props;

  const onModalSubmit = async () => {
    toggle();
    if (onSubmit) {
      await onSubmit()
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop='static' className='assurance-modal'>
      <ModalHeader toggle={toggle}>Add Rating</ModalHeader>
      <ModalBody>
        <RatingForm onSubmit={onModalSubmit} { ...rest } />
      </ModalBody>
    </Modal>
  );
}
